let url;
if (process.env.NODE_ENV === 'development') {

    url = process.env.REACT_APP_URL_LOCAL;
}
if (process.env.NODE_ENV === 'production') {
    url = process.env.REACT_APP_URL_PRODUCCION;
}

//clients
export const urlGetNameClients = url + 'client/nameList';
export const urlDeleteClient = url + 'client/deleteClient';
export const urlCreateClient = url + 'client/createClient';
export const urlGetClients = url + 'client/';
export const urlEditClients = url + 'client/getById?id=';
export const urlGetContactData = url + 'client/getContactData';

//users
export const urlUser = url + 'user/';
export const urlForgotPassword = url + 'user/forgotPassword';
export const urlCreateUser = url + 'user/createUser';
export const urlUpdatePassword = url + 'user/updatePassword';
export const urlUpdateEmail = url + 'user/updateEmail';
export const urlUpdateTel = url + 'user/updateTel';
export const urlUserGetById = url + 'user/getById?id=';

//auth
export const urlLogin = url + 'auth/login';

// estimate
export const urlCreateEstimate = url + 'estimate';
export const urlDatatableEstimate = url + 'estimate/getDatatable';
export const urlGetEstimateById = url + 'estimate/getById';
export const urlGetEstimateByClientId = url + 'estimate/getByClientId?id=';
export const urlGetEstimateByAddressWork = url + 'estimate/getByAddressWork?addressWork=';
export const urlGetNextCall = url + 'estimate/getNextCall';

// certification 
export const urlCertification = url + 'certification';
export const urlGetCertificationById = url + 'certification/getById';
export const urlGetCertificationByWorkId = url + 'certification/getByWorkId';

// products
export const urlProduct = url + 'product';
export const urlProductById = url + 'product/getById?id=';

// works
export const urlWorks = url + 'work';
export const urlGetByClientIdWorks = url + 'work/getByClientId?id=';
export const urlGetByIdWorks = url + 'work/getById?id=';
